import script from "./ReportAppendix_LeftModify.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportAppendix_LeftModify.vue?vue&type=script&setup=true&lang=js"

import "./ReportAppendix_LeftModify.vue?vue&type=style&index=0&id=497191be&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-497191be"]])

export default __exports__